import {
  Button,
  Card,
  Col,
  Form,
  Overlay,
  Popover,
  Spinner,
  Row,
  Badge,
  OverlayTrigger,
  Tooltip,
  Dropdown,
  Modal,
  Image
} from "react-bootstrap";
// import AdvancedImage from "../../components/AdvancedImage";
import React, { useEffect, useRef, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import "./Medium.module.scss";
import { useHotkeys } from "react-hotkeys-hook";
import _ from "lodash";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { mediumsConstants } from "../../constants";
import ReactPlayer from "react-player";
import { projectsConstants } from "../../constants";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faProjectDiagram,
  faEye,
  faSearch,
  faQuoteLeft,
  faUser,
  faFolder,
  faGavel,
  faPlay,
  faPause,
  faVolumeUp,
  faVolumeDown,
  faVolumeMute,
  faExpand,
  faEyeSlash,
  faAdjust,
  faUndo,
  faRedo,
  faSearchPlus,
  faSearchMinus,
  faExpandArrowsAlt,
  faTimes
} from '@fortawesome/free-solid-svg-icons';
import styles from './Medium.module.scss';
import { Attendance } from "../attendance/Attendance";
import { useNavigate } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
// import HEICViewer from "../../components/CustomImage/HEICViewer";

const MediaContainer = ({ url, mediaType, onClose, isStoryboard = false }) => {
  const containerRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isPlaying, setIsPlaying] = useState(true);
  const [volume, setVolume] = useState(0.8);
  const [played, setPlayed] = useState(0);
  const [duration, setDuration] = useState(0);
  const [seeking, setSeeking] = useState(false);
  const [playbackRate, setPlaybackRate] = useState(1);
  const playerRef = useRef(null);

  // Video zoom state
  const [videoScale, setVideoScale] = useState(1);
  const [videoPosition, setVideoPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const videoContainerRef = useRef(null);
  // Toggle between ReactPlayer and simple HTML5 <video> player
  // const [useSimplePlayer, setUseSimplePlayer] = useState(false);

  const handleFullscreen = () => {
    if (!document.fullscreenElement) {
      containerRef.current?.requestFullscreen().catch(err => {
        console.error(`Error attempting to enable fullscreen: ${err.message}`);
      });
    } else {
      document.exitFullscreen();
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, []);

  // Video control handlers
  const handleProgress = (state) => {
    if (!seeking) {
      setPlayed(state.played);
    }
  };

  const handleDuration = (duration) => {
    setDuration(duration);
  };

  const handlePlayPause = () => {
    setIsPlaying(!isPlaying);
  };

  const handleSeekMouseDown = () => {
    setSeeking(true);
  };

  const handleSeekChange = (e) => {
    const seekTime = parseFloat(e.target.value);
    setPlayed(seekTime);
  };

  const handleSeekMouseUp = (e) => {
    setSeeking(false);
    const seekTime = parseFloat(e.target.value);
    if (playerRef.current) {
      playerRef.current.seekTo(seekTime);
    }
  };

  const handleSeekClick = (e) => {
    const rect = e.target.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const width = rect.width;
    const seekTime = Math.max(0, Math.min(1, clickX / width));
    setPlayed(seekTime);
    setSeeking(false);
    if (playerRef.current) {
      playerRef.current.seekTo(seekTime);
    }
  };

  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
  };

  const handlePlaybackRateChange = (rate) => {
    setPlaybackRate(rate);
  };

  const formatTime = (seconds) => {
    if (isNaN(seconds)) return '0:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const getVolumeIcon = () => {
    if (volume === 0) return faVolumeMute;
    if (volume < 0.5) return faVolumeDown;
    return faVolumeUp;
  };

  // Video zoom and pan handlers
  const handleMouseDown = (e) => {
    if (mediaType !== mediumsConstants.VIDEO || videoScale <= 1) return;

    e.preventDefault();
    setIsDragging(true);
    setDragStart({
      x: e.clientX - videoPosition.x,
      y: e.clientY - videoPosition.y
    });
  };

  const handleMouseMove = (e) => {
    if (!isDragging || mediaType !== mediumsConstants.VIDEO) return;

    e.preventDefault();
    setVideoPosition({
      x: e.clientX - dragStart.x,
      y: e.clientY - dragStart.y
    });
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const resetVideoZoom = () => {
    setVideoScale(1);
    setVideoPosition({ x: 0, y: 0 });
  };

  // Add event listeners for mouse events
  useEffect(() => {
    if (mediaType === mediumsConstants.VIDEO) {
      const container = videoContainerRef.current;
      if (container) {
        container.addEventListener('mousemove', handleMouseMove);
        container.addEventListener('mouseup', handleMouseUp);
        container.addEventListener('mouseleave', handleMouseUp);

        return () => {
          container.removeEventListener('mousemove', handleMouseMove);
          container.removeEventListener('mouseup', handleMouseUp);
          container.removeEventListener('mouseleave', handleMouseUp);
        };
      }
    }
  }, [mediaType, isDragging, dragStart, videoPosition]);

  const renderMediaContent = () => {
    if (mediaType === mediumsConstants.VIDEO) {
      return (
        <div className="w-100 h-100 d-flex flex-column">
          <div className="d-flex justify-content-end mb-2">
            <Button variant="primary" className="mr-2" onClick={() => setVideoScale(Math.min(5, videoScale + 0.2))} title="Zoom In">
              <FontAwesomeIcon icon={faSearchPlus} />
            </Button>
            <Button variant="info" className="mr-2" onClick={() => setVideoScale(Math.max(0.1, videoScale - 0.2))} title="Zoom Out">
              <FontAwesomeIcon icon={faSearchMinus} />
            </Button>
            <Button variant="secondary" className="mr-2" onClick={resetVideoZoom} title="Reset Zoom">
              <FontAwesomeIcon icon={faUndo} />
            </Button>
            <Button variant="warning" className="mr-2" onClick={handleFullscreen} title={isFullscreen ? "Exit Fullscreen" : "Fullscreen"}>
              <FontAwesomeIcon icon={faExpandArrowsAlt} />
            </Button>
            {/* <Button variant="light" className="mr-2" onClick={() => setUseSimplePlayer(prev => !prev)} title="Switch player">
              Switch player
            </Button> */}
            {onClose && (
              <Button variant="danger" onClick={onClose} title="Close">
                <FontAwesomeIcon icon={faTimes} />
              </Button>
            )}
          </div>
          <div
            ref={videoContainerRef}
            className="flex-grow-1 d-flex align-items-center justify-content-center position-relative"
            style={{
              backgroundColor: '#000',
              overflow: 'hidden',
              cursor: videoScale > 1 ? (isDragging ? 'grabbing' : 'grab') : 'default'
            }}
            onMouseDown={handleMouseDown}
          >
            <div
              style={{
                transform: `scale(${videoScale}) translate(${videoPosition.x / videoScale}px, ${videoPosition.y / videoScale}px)`,
                transformOrigin: 'center center',
                transition: isDragging ? 'none' : 'transform 0.1s ease-out',
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {/* {useSimplePlayer ? ( */}
                <video
                  ref={playerRef}
                  src={url}
                  controls
                  autoPlay={isPlaying}
                  playsInline
                  style={{ width: '100%', height: '100%' }}
                  controlsList="nodownload noremoteplayback"
                  disablePictureInPicture
                  disableRemotePlayback
                />
              {/* ) : (
                <ReactPlayer
                  ref={playerRef}
                  url={url}
                  playing={isPlaying}
                  volume={volume}
                  playbackRate={playbackRate}
                  muted={false}
                  light={false}
                  controls={false}
                  pip={false}
                  loop={false}
                  playsinline={true}
                  autoPlay={true}
                  width="100%"
                  height="100%"
                  onProgress={handleProgress}
                  onDuration={handleDuration}
                  config={{
                    file: {
                      attributes: {
                        preload: 'metadata',
                        playsInline: true,
                        crossOrigin: 'anonymous'
                      }
                    }
                  }}
                />
              )} */}
            </div>

            {/* Zoom controls overlay */}


            {/* Zoom level indicator */}
            {videoScale !== 1 && (
              <div className="position-absolute" style={{ bottom: '10px', left: '10px', zIndex: 10 }}>
                <span className="badge bg-dark text-white">
                  {Math.round(videoScale * 100)}%
                </span>
              </div>
            )}
          </div>
          {/* <div className="bg-dark text-white p-2">
            <CustomVideoControls
              isPlaying={isPlaying}
              played={played}
              duration={duration}
              volume={volume}
              playbackRate={playbackRate}
              onPlayPause={handlePlayPause}
              onSeekMouseDown={handleSeekMouseDown}
              onSeekChange={handleSeekChange}
              onSeekMouseUp={handleSeekMouseUp}
              onSeekClick={handleSeekClick}
              onVolumeChange={handleVolumeChange}
              onPlaybackRateChange={handlePlaybackRateChange}
              onFullscreen={handleFullscreen}
              formatTime={formatTime}
              blurActive={false}
              grayscaleActive={false}
              onToggleBlur={() => { }}
              onToggleGrayscale={() => { }}
              onRotateLeft={() => { }}
              onRotateRight={() => { }}
            />
          </div> */}
        </div>
      );
    } else if (isStoryboard) {
      // For storyboards, use full-width transform wrapper
      return (
        <TransformWrapper
          defaultScale={1}
          defaultPositionX={0}
          defaultPositionY={0}
          wrapperStyle={{ width: '100%', height: 'auto' }}
          contentStyle={{ width: '100%', height: 'auto' }}
        >
          {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
            <React.Fragment>
              <div className="d-flex justify-content-end mb-2">
                <Button variant="primary" className="mr-2" onClick={zoomIn} title="Zoom In">
                  <FontAwesomeIcon icon={faSearchPlus} />
                </Button>
                <Button variant="info" className="mr-2" onClick={zoomOut} title="Zoom Out">
                  <FontAwesomeIcon icon={faSearchMinus} />
                </Button>
                <Button variant="secondary" className="mr-2" onClick={resetTransform} title="Reset Zoom">
                  <FontAwesomeIcon icon={faUndo} />
                </Button>
                <Button variant="warning" className="mr-2" onClick={handleFullscreen} title={isFullscreen ? "Exit Fullscreen" : "Fullscreen"}>
                  <FontAwesomeIcon icon={faExpandArrowsAlt} />
                </Button>
                {onClose && (
                  <Button variant="danger" onClick={onClose} title="Close">
                    <FontAwesomeIcon icon={faTimes} />
                  </Button>
                )}
              </div>
              <TransformComponent className="storyboard-zoom-transform-component" 
                  style={{ width: '100%', height: 'auto'}}>
                <Image 
                  src={url} 
                  className="img-fluid d-block m-auto" 
                  alt="Storyboard"
                  style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
                />
              </TransformComponent>
            </React.Fragment>
          )}
        </TransformWrapper>
      );
    } else {
      // For regular images, use the transform wrapper for zoom functionality
      return (
        <TransformWrapper
          defaultScale={1}
          defaultPositionX={200}
          defaultPositionY={100}
        >
          {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
            <React.Fragment>
              <div className="d-flex justify-content-end mb-2">
                <Button variant="primary" className="mr-2" onClick={zoomIn} title="Zoom In">
                  <FontAwesomeIcon icon={faSearchPlus} />
                </Button>
                <Button variant="info" className="mr-2" onClick={zoomOut} title="Zoom Out">
                  <FontAwesomeIcon icon={faSearchMinus} />
                </Button>
                <Button variant="secondary" className="mr-2" onClick={resetTransform} title="Reset Zoom">
                  <FontAwesomeIcon icon={faUndo} />
                </Button>
                <Button variant="warning" className="mr-2" onClick={handleFullscreen} title={isFullscreen ? "Exit Fullscreen" : "Fullscreen"}>
                  <FontAwesomeIcon icon={faExpandArrowsAlt} />
                </Button>
                {onClose && (
                  <Button variant="danger" onClick={onClose} title="Close">
                    <FontAwesomeIcon icon={faTimes} />
                  </Button>
                )}
              </div>
              <TransformComponent>
                <Image 
                  src={url} 
                  className="img-fluid d-block m-auto" 
                  alt=""
                />
              </TransformComponent>
            </React.Fragment>
          )}
        </TransformWrapper>
      );
    }
  };

  return (
    <div ref={containerRef} style={{ backgroundColor: isFullscreen ? '#fff' : 'transparent' }}>
      {renderMediaContent()}
      {mediaType === mediumsConstants.VIDEO && (
        <div className="d-flex justify-content-end mt-2">
          <Button variant="warning" className="mr-2" onClick={handleFullscreen} title={isFullscreen ? "Exit Fullscreen" : "Fullscreen"}>
            <FontAwesomeIcon icon={faExpandArrowsAlt} />
          </Button>
          {onClose && (
            <Button variant="danger" onClick={onClose} title="Close">
              <FontAwesomeIcon icon={faTimes} />
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

const CustomVideoControls = ({
  isPlaying,
  played,
  duration,
  volume,
  playbackRate,
  onPlayPause,
  onSeekMouseDown,
  onSeekChange,
  onSeekMouseUp,
  onSeekClick,
  onVolumeChange,
  onPlaybackRateChange,
  onFullscreen,
  formatTime,
  blurActive,
  grayscaleActive,
  onToggleBlur,
  onToggleGrayscale,
  onRotateLeft,
  onRotateRight,
  onCreateKeyframe
}) => {
  const [showSpeedMenu, setShowSpeedMenu] = React.useState(false);
  const [menuPosition, setMenuPosition] = React.useState({ top: 0, left: 0 });
  const speedButtonRef = React.useRef(null);
  const speedOptions = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];

  const getVolumeIcon = () => {
    if (volume === 0) return faVolumeMute;
    if (volume < 0.5) return faVolumeDown;
    return faVolumeUp;
  };

  return (
    <div className={styles['custom-video-controls-container']}>
      <div className={styles['video-controls-row-1']}>
        <button
          onClick={onPlayPause}
          className={styles['video-control-button']}
          title={isPlaying ? 'Pause' : 'Play'}
        >
          <FontAwesomeIcon
            icon={isPlaying ? faPause : faPlay}
            className={styles['fa-icon']}
          />
        </button>

        <span className={styles['video-time-display']}>
          {formatTime(played * duration)} / {formatTime(duration)}
        </span>

        <input
          type="range"
          min={0}
          max={1}
          step="any"
          value={played || 0}
          onMouseDown={onSeekMouseDown}
          onChange={onSeekChange}
          onMouseUp={onSeekMouseUp}
          onClick={onSeekClick}
          title={`Progress: ${Math.round((played || 0) * 100)}%`}
          className={styles['video-progress-bar']}
        />

        <div className={styles['video-speed-control']}>
          <button
            ref={speedButtonRef}
            onClick={() => {
              if (!showSpeedMenu && speedButtonRef.current) {
                const rect = speedButtonRef.current.getBoundingClientRect();
                setMenuPosition({
                  top: rect.top - 8,
                  left: rect.left
                });
              }
              setShowSpeedMenu(!showSpeedMenu);
            }}
            className={styles['video-control-button-small']}
            title="Playback Speed"
          >
            {playbackRate || 1}x
          </button>
          {showSpeedMenu && (
            <div
              className={styles['video-speed-menu']}
              style={{
                top: `${menuPosition.top}px`,
                left: `${menuPosition.left}px`,
                transform: 'translateY(-100%)'
              }}
            >
              {speedOptions.map(speed => (
                <button
                  key={speed}
                  onClick={() => {
                    onPlaybackRateChange && onPlaybackRateChange(speed);
                    setShowSpeedMenu(false);
                  }}
                  className={styles['video-speed-option']}
                >
                  {speed}x
                </button>
              ))}
            </div>
          )}
        </div>

        <div className={styles['video-volume-control']}>
          <div className={styles['video-volume-icon']}>
            <FontAwesomeIcon
              icon={getVolumeIcon()}
              className={styles['fa-icon']}
              title="Volume"
            />
          </div>
          <input
            type="range"
            min={0}
            max={1}
            step="any"
            value={volume}
            onChange={onVolumeChange}
            title={`Volume: ${Math.round(volume * 100)}%`}
            className={styles['video-volume-slider']}
          />
        </div>

        <button
          onClick={onFullscreen}
          className={styles['video-control-button']}
          title="Fullscreen"
        >
          <FontAwesomeIcon
            icon={faExpand}
            className={styles['fa-icon']}
          />
        </button>
      </div>

      <div className={styles['video-controls-row-2']}>
        <button
          onClick={onCreateKeyframe}
          className={`${styles['video-filter-button']} ${styles['keyframe-button']}`}
          title="Create keyframe at current time"
        >
          <FontAwesomeIcon icon={faProjectDiagram} />
        </button>

        <button
          onClick={onToggleBlur}
          className={`${styles['video-filter-button']} ${blurActive ? styles['active'] : ''}`}
          title={blurActive ? "Remove blur filter" : "Apply blur filter"}
        >
          <FontAwesomeIcon icon={faEyeSlash} />
        </button>

        <button
          onClick={onToggleGrayscale}
          className={`${styles['video-filter-button']} ${grayscaleActive ? styles['active'] : ''}`}
          title={grayscaleActive ? "Remove grayscale filter" : "Apply grayscale filter"}
        >
          <FontAwesomeIcon icon={faAdjust} />
        </button>

        <button
          onClick={onRotateLeft}
          className={styles['video-filter-button']}
          title="Rotate 90 degrees counterclockwise"
        >
          <FontAwesomeIcon icon={faUndo} />
        </button>

        <button
          onClick={onRotateRight}
          className={styles['video-filter-button']}
          title="Rotate 90 degrees clockwise"
        >
          <FontAwesomeIcon icon={faRedo} />
        </button>
      </div>
    </div>
  );
};

// const KeyframeControls = ({
//   media,
//   keyframes,
//   selectedKeyframe,
//   onKeyframeClick,
//   onKeyframeDelete
// }) => {
//   if (media?.media_type !== mediumsConstants.VIDEO) {
//     return null;
//   }

//   return (
//     <div className={`${styles['keyframe-controls-reference']} h-100 d-flex flex-column`}>
//       <div className="d-flex align-items-center justify-content-between mb-2">
//         <h6 className={`mb-0 text-secondary font-weight-bold ${styles['keyframe-header-text']}`}>
//           Keyframe Controls ({keyframes.length})
//         </h6>
//       </div>

//       <div className="flex-grow-1">
//         {keyframes.length === 0 ? (
//           <div className="d-flex align-items-center justify-content-center h-100">
//             <div className="text-center">
//               <FontAwesomeIcon icon={faProjectDiagram} className="text-muted mb-2" size="2x" />
//               <p className="text-muted small mb-0">No keyframes created</p>
//               <p className="text-muted small">Click the keyframe button in video controls to create one</p>
//             </div>
//           </div>
//         ) : (
//           <Row className="g-2 h-100">
//             {keyframes.map((keyframe) => (
//               <Col key={keyframe.id} xs={6} className="mb-2">
//                 <div className={`${styles['keyframe-reference-item']} h-100`}>
//                   <div
//                     className={`${styles['keyframe-reference-thumbnail']} ${selectedKeyframe === keyframe.id ? styles['selected'] : ''}`}
//                     onClick={() => onKeyframeClick && onKeyframeClick(keyframe)}
//                   >
//                     {/* Timestamp at top */}
//                     <div className={styles['timestamp-display']}>
//                       <small className="text-white bg-dark px-2 py-1 rounded">
//                         {keyframe.timestampFormatted}
//                       </small>
//                     </div>

//                     {/* Frame preview area */}
//                     <div className={styles['frame-preview-area']}>
//                       {keyframe.thumbnail ? (
//                         <AdvancedImage
//                           src={keyframe.thumbnail}
//                           alt={keyframe.label}
//                           style={{
//                             width: '100%',
//                             height: '100%',
//                             objectFit: 'cover',
//                             borderRadius: '4px'
//                           }}
//                         />
//                       ) : (
//                         <div className={styles['frame-placeholder']}>
//                           <small className="text-muted">Frame {keyframe.id}</small>
//                         </div>
//                       )}
//                     </div>

//                     {/* Delete button */}
//                     {onKeyframeDelete && (
//                       <button
//                         className="btn btn-sm btn-danger position-absolute"
//                         style={{ top: '5px', right: '5px', padding: '2px 6px' }}
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           onKeyframeDelete(keyframe.id);
//                         }}
//                         title="Delete keyframe"
//                       >
//                         ×
//                       </button>
//                     )}
//                   </div>

//                   {/* Label below thumbnail */}
//                   <div className="text-center mt-1">
//                     <small className={`text-dark font-weight-medium ${styles['keyframe-label-text']}`}>
//                       {keyframe.label}
//                     </small>
//                   </div>
//                 </div>
//               </Col>
//             ))}
//           </Row>
//         )}
//       </div>
//     </div>
//   );
// };

function GetMediaUrl(media, project, showConvertedImage = true) {
  const server = process.env.REACT_APP_BASE_URL;

  // Check if media_path is a GCP URL (contains storage.googleapis.com or signed URL parameters)
  const isGcpUrl = media["media_path"] && (
    media["media_path"].includes('storage.googleapis.com') ||
    media["media_path"].includes('X-Goog-Algorithm') ||
    media["media_path"].startsWith('https://')
  );

  // If it's a GCP URL, use it directly since CORS is now configured
  if (isGcpUrl) {
    return media["media_path"];
  }

  // For images, check if we have both converted and original versions (legacy local storage)
  if (media["media_type"] === mediumsConstants.IMAGE) {
    // const originalExtension = media["media_path"] ? media["media_path"].split('.').pop() : '';
    // const isUnsupportedFormat = ['tiff', 'tif', 'cr2', 'orf', 'heic', 'heif', 'ppm'].includes(originalExtension.toLowerCase());

    // if (isUnsupportedFormat) {
    if (showConvertedImage) {
      const contentType = media["media_download"]?.note;
      const convertedPath = media["media_path"] ? media["media_path"].replace(/\.[^/.]+$/, '.' + contentType) : '';
      return `${server}/storage/media/${project.id}/${convertedPath}`;
    } else {
      // Show original format
      return `${server}/storage/media/${project.id}/${media["media_path"]}`;
    }
    // }
  }

  // ORIGINAL LOGIC: Server-based media paths for non-images or supported formats (legacy local storage)
  let mediaUrl = !media["note"].includes(mediumsConstants.TEST_IMAGE)
    ? `${server}/storage/media/${project.id}/${media["media_path"]}`
    : `${server}/storage/media/test/${media["media_path"]}`;

  // if (
  //   project.name === projectsConstants.VID_STREAMING &&
  //   !media["note"].includes(mediumsConstants.TEST_IMAGE)
  // ) {
  //   mediaUrl = media["media_url"];
  // }

  return mediaUrl;
}

const Media = ({
  media,
  selectedLabelIds,
  labels,
  onMouseClick,
  project,
  updateMediaInfo,
  category,
  showConvertedImage,
  isPlaying,
  setIsPlaying,
}) => {
  const [activeLabelColor, setActiveLabelColor] = useState(null);
  const [isMediaOpacity, setMediaOpacity] = useState(false);
  const [opacity, setOpacity] = useState(1);
  const [mediaLoaded, setMediaLoaded] = useState(null);
  const [mediaErrored, setMediaErrored] = useState(null);

  // Enhanced ReactPlayer state management
  const [volume, setVolume] = useState(0.8);
  const [played, setPlayed] = useState(0);
  const [duration, setDuration] = useState(0);
  const [seeking, setSeeking] = useState(false);
  const [playbackRate, setPlaybackRate] = useState(1);
  const [videoReady, setVideoReady] = useState(false);
  const [videoError, setVideoError] = useState(false);
  const [videoLoading, setVideoLoading] = useState(true);

  // Video filter states
  const [blurActive, setBlurActive] = useState(false);
  const [grayscaleActive, setGrayscaleActive] = useState(false);
  const [rotationAngle, setRotationAngle] = useState(0);

  // Keyframe functionality states
  const [keyframes, setKeyframes] = useState([]);
  const [selectedKeyframe, setSelectedKeyframe] = useState(null);
  const [keyframeCounter, setKeyframeCounter] = useState(1);

  // Video fallback state
  const [useFallbackVideo, setUseFallbackVideo] = useState(false);

  // Player reference for direct control
  const playerRef = useRef(null);
  // Video container reference for fullscreen functionality
  const videoContainerRef = useRef(null);
  // Canvas reference for thumbnail generation
  const canvasRef = useRef(null);

  // State to track current media URL
  const [mediaUrl, setMediaUrl] = useState(GetMediaUrl(media, project, showConvertedImage));

  // Update mediaUrl when showConvertedImage changes
  useEffect(() => {
    const newUrl = GetMediaUrl(media, project, showConvertedImage);
    // console.log('Media URL updated:', { showConvertedImage, newUrl, oldUrl: mediaUrl });
    setMediaUrl(newUrl);
  }, [showConvertedImage, media, project]);

  // Auto play effect - ensure video starts playing when ready
  useEffect(() => {
    if (videoReady && !isPlaying) {
      setIsPlaying(true);
    }
  }, [videoReady, isPlaying]);

  // const mediaUrl = GetMediaUrl(media, project, showConvertedImage);
  // const mediaUrl = '/videos/test.mp4';

  // Add after other useState hooks in Media component
  const [extractingFrames, setExtractingFrames] = useState(false);

  // Add autoExtractFrames function inside Media component
  const autoExtractFrames = async (interval = 2) => {
    if (!playerRef.current) return;
    const internalPlayer = playerRef.current.getInternalPlayer();
    if (!internalPlayer || !internalPlayer.duration || isNaN(internalPlayer.duration) || !isFinite(internalPlayer.duration)) return;

    setExtractingFrames(true);
    const duration = internalPlayer.duration;
    const frames = [];
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    canvas.width = internalPlayer.videoWidth;
    canvas.height = internalPlayer.videoHeight;

    let keyframeId = 1;
    const maxFrames = 1000;
    let frameCount = 0;

    const seekAndCapture = (time) => {
      return new Promise((resolve) => {
        const onSeeked = () => {
          ctx.drawImage(internalPlayer, 0, 0, canvas.width, canvas.height);
          const thumbnail = canvas.toDataURL('image/jpeg', 0.8);
          frames.push({
            id: keyframeId,
            timestamp: time,
            timestampFormatted: formatTime(time),
            thumbnail,
            label: `Keyframe ${keyframeId}`
          });
          keyframeId++;
          internalPlayer.removeEventListener('seeked', onSeeked);
          resolve();
        };
        internalPlayer.addEventListener('seeked', onSeeked);
        internalPlayer.currentTime = time;
      });
    };

    for (let t = 0; t < duration && frameCount < maxFrames; t += interval, frameCount++) {
      await seekAndCapture(t);
    }

    setKeyframes(frames);
    setSelectedKeyframe(frames.length > 0 ? frames[0].id : null);
    setExtractingFrames(false);

    // Reset video position to beginning after frame extraction
    if (playerRef.current) {
      playerRef.current.seekTo(0);
      setPlayed(0);
    }
  };


  // // ENHANCED: Video URL with fallback logic for local/remote sources
  // const getVideoUrlWithFallback = () => {
  //   const primaryUrl = mediaUrl;

  //   // For local videos, provide fallback to remote URL if available
  //   if (primaryUrl.startsWith("/videos/") && media["media_url"] !== primaryUrl) {
  //     // If we have a different remote URL as backup, we could use it
  //     // For now, just return the primary URL
  //     return primaryUrl;
  //   }

  //   return primaryUrl;
  // };

  // const videoUrl = getVideoUrlWithFallback();

  let mediaType = media["media_type"];
  useEffect(() => {
    // Use the first selected label for visual effects
    const activeLabelId = selectedLabelIds.length > 0 ? selectedLabelIds[0] : null;
    const label = _.find(labels, (el) => el.id === activeLabelId);
    if (!label) {
      return;
    }
    setActiveLabelColor(label.color);
    setMediaOpacity(label.opacity);
    if (label.opacity) {
      setOpacity(0.4);
    } else {
      setOpacity(1);
    }
  }, [selectedLabelIds, labels]);

  const getMediaInfo = () => {
    let result = "Video";
    let mediaType = media["media_type"];
    if (mediaType === mediumsConstants.IMAGE) {
      result = "Image";
    } else if (mediaType === mediumsConstants.GIF) {
      result = "Gif";
    } else if (mediaType === mediumsConstants.AUDIO) {
      result = "Audio";
    }
    return result;
  };

  // Enhanced ReactPlayer control handlers
  const handleProgress = (state) => {
    if (!seeking) {
      setPlayed(state.played);

      // Check if current playback time matches any keyframe (within 0.5 second tolerance)
      const currentTime = state.played * duration;
      const activeKeyframe = keyframes.find(kf =>
        Math.abs(kf.timestamp - currentTime) < 0.5
      );

      if (activeKeyframe && selectedKeyframe !== activeKeyframe.id) {
        setSelectedKeyframe(activeKeyframe.id);
      }
    }
  };

  const handleDuration = (duration) => {
    setDuration(duration);
  };

  const handlePlayPause = () => {
    const newPlayingState = !isPlaying;
    setIsPlaying(newPlayingState);

    // Handle ReactPlayer reference if available
    if (playerRef.current) {
      // ReactPlayer handles playing state automatically via the playing prop
    }
  };

  const handleSeekMouseDown = () => {
    setSeeking(true);
  };

  const handleSeekChange = (e) => {
    const seekTime = parseFloat(e.target.value);
    setPlayed(seekTime);

    // If not currently seeking (dragging), treat this as a click and seek immediately
    if (!seeking && playerRef.current) {
      playerRef.current.seekTo(seekTime);
    }
  };

  const handleSeekMouseUp = (e) => {
    setSeeking(false);
    const seekTime = parseFloat(e.target.value);

    if (playerRef.current) {
      // ReactPlayer seek method
      playerRef.current.seekTo(seekTime);
    }
  };

  // Handle direct clicks on progress bar for immediate seeking
  const handleSeekClick = (e) => {
    // Calculate the exact position clicked on the progress bar
    const rect = e.target.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const width = rect.width;
    const seekTime = Math.max(0, Math.min(1, clickX / width));

    setPlayed(seekTime);
    setSeeking(false); // Ensure seeking state is reset

    if (playerRef.current) {
      // ReactPlayer seek method for direct clicks
      playerRef.current.seekTo(seekTime);
    }
  };

  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    // ReactPlayer handles volume automatically via the volume prop
  };

  const handlePlaybackRateChange = (rate) => {
    setPlaybackRate(rate);
    // ReactPlayer handles playback rate automatically via the playbackRate prop
  };

  // Video filter handler functions
  const handleToggleBlur = () => {
    setBlurActive(!blurActive);
  };

  const handleToggleGrayscale = () => {
    setGrayscaleActive(!grayscaleActive);
  };

  const handleRotateLeft = () => {
    setRotationAngle(prevAngle => prevAngle - 90);
  };

  const handleRotateRight = () => {
    setRotationAngle(prevAngle => prevAngle + 90);
  };

  const handleFullscreen = () => {
    // Check if currently in fullscreen mode
    const isFullscreen = !!(
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    );

    if (isFullscreen) {
      // Exit fullscreen mode
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    } else {
      // Enter fullscreen mode using the video element directly
      const videoElement = playerRef.current?.getInternalPlayer();
      if (videoElement && videoElement.tagName === 'VIDEO') {
        // Use the video element directly for fullscreen
        if (videoElement.requestFullscreen) {
          videoElement.requestFullscreen();
        } else if (videoElement.webkitRequestFullscreen) {
          videoElement.webkitRequestFullscreen();
        } else if (videoElement.mozRequestFullScreen) {
          videoElement.mozRequestFullScreen();
        } else if (videoElement.msRequestFullscreen) {
          videoElement.msRequestFullscreen();
        }
      } else {
        // Fallback to container if video element not available
        const videoContainer = videoContainerRef.current;
        if (videoContainer) {
          if (videoContainer.requestFullscreen) {
            videoContainer.requestFullscreen();
          } else if (videoContainer.webkitRequestFullscreen) {
            videoContainer.webkitRequestFullscreen();
          } else if (videoContainer.mozRequestFullScreen) {
            videoContainer.mozRequestFullScreen();
          } else if (videoContainer.msRequestFullscreen) {
            videoContainer.msRequestFullscreen();
          }
        }
      }
    }
  };

  // Format time for display
  const formatTime = (seconds) => {
    if (isNaN(seconds)) return '0:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  // Keyframe functionality functions
  const generateThumbnail = () => {
    if (!playerRef.current) return null;

    try {
      // Get the internal video element from ReactPlayer
      const internalPlayer = playerRef.current.getInternalPlayer();
      if (!internalPlayer || !internalPlayer.videoWidth || !internalPlayer.videoHeight) {
        return null;
      }

      // Create canvas for thumbnail generation
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // Set canvas dimensions to match video aspect ratio but smaller for thumbnail
      const aspectRatio = internalPlayer.videoWidth / internalPlayer.videoHeight;
      canvas.width = 160; // Fixed width for thumbnails
      canvas.height = 160 / aspectRatio;

      // Draw current video frame to canvas
      ctx.drawImage(internalPlayer, 0, 0, canvas.width, canvas.height);

      // Convert canvas to data URL
      return canvas.toDataURL('image/jpeg', 0.8);
    } catch (error) {
      console.warn('Failed to generate thumbnail:', error);
      return null;
    }
  };

  const createKeyframe = () => {
    if (!playerRef.current || !duration) return;

    const currentTime = played * duration;
    const thumbnail = generateThumbnail();

    const newKeyframe = {
      id: keyframeCounter,
      timestamp: currentTime,
      timestampFormatted: formatTime(currentTime),
      thumbnail: thumbnail,
      label: `Keyframe ${keyframeCounter}`
    };

    setKeyframes(prev => [...prev, newKeyframe]);
    setKeyframeCounter(prev => prev + 1);
    setSelectedKeyframe(newKeyframe.id);
  };

  const navigateToKeyframe = (keyframe) => {
    if (!playerRef.current || !duration) return;

    const seekTime = keyframe.timestamp / duration;
    setPlayed(seekTime);
    setSeeking(false);
    setSelectedKeyframe(keyframe.id);

    // Seek to the keyframe timestamp
    playerRef.current.seekTo(seekTime);
  };

  const deleteKeyframe = (keyframeId) => {
    setKeyframes(prev => prev.filter(kf => kf.id !== keyframeId));
    if (selectedKeyframe === keyframeId) {
      setSelectedKeyframe(null);
    }
  };

  // Generate CSS filter styles for video content only (blur and grayscale)
  const getVideoContentStyles = () => {
    const filters = [];

    if (blurActive) {
      filters.push('blur(3px)');
    }

    if (grayscaleActive) {
      filters.push('grayscale(100%)');
    }

    return {
      filter: filters.length > 0 ? filters.join(' ') : 'none',
      transition: 'filter 0.3s ease'
    };
  };

  // Generate CSS rotation styles for video content only
  const getVideoRotationStyles = () => {
    return {
      transform: rotationAngle !== 0 ? `rotate(${rotationAngle}deg)` : 'none',
      transition: 'transform 0.3s ease'
    };
  };

  const loaded = () => {
    if (!mediaLoaded) {
      setMediaLoaded(true);
      updateMediaInfo(getMediaInfo() + " | 100% Loaded");
    }
  };

  const errored = (ev) => {
    if (!mediaErrored) {
      updateMediaInfo(getMediaInfo() + " | Failed To Load");
      setMediaErrored(true);
    }

    if (project.name === projectsConstants.RACECAR) {
      ev.target.src = "/race_car_no_photo.png";
    }
  };
  let content;

  if (project.name === projectsConstants.LOVE_AUDIO) {
    mediaType = mediumsConstants.AUDIO;
  }
  if (
    mediaType === mediumsConstants.IMAGE ||
    mediaType === mediumsConstants.GIF
  ) {
    content = (
      <>
        {/* <AdvancedImage
        onLoad={loaded}
        onError={errored}
        src={mediaUrl}
        className={`img-fluid ${isMediaOpacity ? styles["media-opacity"] : ""}`}
        fallbackSrc="/race_car_no_photo.png"
      /> */}
        <img
          onLoad={loaded}
          onError={errored}
          src={mediaUrl}
          // alt="Media content"
          className={`img-fluid ${isMediaOpacity ? styles["media-opacity"] : ""}`}
        // onError={(e) => {
        //   e.target.src = "/race_car_no_photo.png";
        //   if (errored) errored(e);
        // }}
        />
        {/* <HEICViewer imageUrl={mediaUrl} /> */}
      </>
    );
  } else if (mediaType === mediumsConstants.VIDEO) {

    // Check if note contains a GCP URL (storyboard URL)
    const isGcpStoryboard = media["note"] && (
      media["note"].includes('storage.googleapis.com') ||
      media["note"].includes('X-Goog-Algorithm') ||
      media["note"].startsWith('https://')
    );
    const localStoryBoard = isGcpStoryboard
      ? media["note"]
      : `${process.env.REACT_APP_BASE_URL}/storage/media/${project.id}/${media["note"]}`;
    content = (
      <div className={styles['video-with-keyframes-container']}>
        {/* Left Side - Video Player Area (70% width) */}
        <div className={styles['video-player-wrapper']} ref={videoContainerRef}>
          {/* Video Content Area - Only this part gets rotated and filtered */}
          <div className={styles['video-content-area']}>
            <div
              className={styles['video-rotation-wrapper']}
              style={{
                ...getVideoRotationStyles(), // Apply rotation only to this wrapper
                ...getVideoContentStyles() // Apply blur and grayscale filters only to video content
              }}
            >
              <ReactPlayer
                ref={playerRef}
                url={mediaUrl}
                // width="100%"
                // height="100%"
                playing={isPlaying}
                volume={volume}
                playbackRate={playbackRate}
                muted={false}
                light={false}
                controls={false} // Use custom controls instead
                pip={false}
                loop={false}
                playsinline={true}
                autoPlay={true} // Enable auto play
                style={{ opacity: opacity }}
                fallback={<div className="d-flex align-items-center justify-content-center h-100 bg-dark text-white">Loading..</div>}
                onReady={() => {
                  setVideoReady(true);
                  setVideoLoading(false);
                  setVideoError(false);
                  loaded(); // Call existing loaded function for compatibility
                }}
                onError={(error) => {
                  setVideoError(true);
                  setVideoLoading(false);
                  setVideoReady(false);
                  errored(error); // Call existing errored function for compatibility
                }}
                onLoadStart={() => {
                  setVideoLoading(true);
                  setVideoError(false);
                }}
                onLoadedMetadata={() => {
                  setVideoReady(true);
                  setVideoLoading(false);
                  setVideoError(false);
                  // autoExtractFrames(2); // Only call here!
                }}
                onCanPlay={() => {
                  setVideoReady(true);
                  setVideoLoading(false);
                  setVideoError(false);
                }}
                onProgress={handleProgress}
                onDuration={handleDuration}
                config={{
                  file: {
                    attributes: {
                      preload: 'metadata',
                      playsInline: true,
                      crossOrigin: 'anonymous' // <-- this line is REQUIRED
                    }
                  }
                }}
              />
            </div>
          </div>

          {/* Custom Controls Area - This stays outside rotation and in normal orientation */}
          <div className={styles['controls-area']}>
            <CustomVideoControls
              isPlaying={isPlaying}
              played={played}
              duration={duration}
              volume={volume}
              playbackRate={playbackRate}
              onPlayPause={handlePlayPause}
              onSeekMouseDown={handleSeekMouseDown}
              onSeekChange={handleSeekChange}
              onSeekMouseUp={handleSeekMouseUp}
              onSeekClick={handleSeekClick}
              onVolumeChange={handleVolumeChange}
              onPlaybackRateChange={handlePlaybackRateChange}
              onFullscreen={handleFullscreen}
              formatTime={formatTime}
              // Filter controls
              blurActive={blurActive}
              grayscaleActive={grayscaleActive}
              onToggleBlur={handleToggleBlur}
              onToggleGrayscale={handleToggleGrayscale}
              onRotateLeft={handleRotateLeft}
              onRotateRight={handleRotateRight}
            // Keyframe controls
            // onCreateKeyframe={createKeyframe}
            />
          </div>
        </div>

        {/* Right Side - Keyframe Controls Area (30% width) */}
        <div className={styles['keyframe-controls-wrapper']}>
          {/* {extractingFrames ? (
            <div className="d-flex align-items-center justify-content-center h-100">
              <Spinner animation="border" variant="primary" />
              <span className="ms-2">Extracting frames...</span>
            </div>
          ) : (
            <KeyframeControls
              media={media}
              keyframes={keyframes}
              selectedKeyframe={selectedKeyframe}
              onKeyframeClick={navigateToKeyframe}
              onKeyframeDelete={deleteKeyframe}
            />
          )} */}
          {media.img_check_details && media.img_check_details.storyboardurl && (
            <>
              {/* <AdvancedImage 
                src={localStoryBoard} 
                alt="Storyboard" 
                className="img-fluid" 
                title="Storyboard"
                fallbackSrc="/race_car_no_photo.png"
              /> */}
              <img
                src={localStoryBoard}
                alt="Storyboard"
                className="img-fluid"
                title="Storyboard"
              // onError={(e) => {
              //   e.target.src = "/race_car_no_photo.png";
              // }}
              />
            </>
          )}
        </div>
      </div>
    );
  } else if (mediaType === mediumsConstants.AUDIO) {
    // content =
    //     <ReactAudioPlayer
    //         src={mediaUrl}
    //         // autoPlay
    //         controls
    //         onError={errored} onReady={loaded}
    //         width="100%" height="100%"
    //         style={{ opacity: opacity }}
    //     />
  }

  let isIS1AlbumHash = false;
  if (project.name === projectsConstants.IS1_ALBUM) {
    if (media["note"] != null) {
      let media_note = media["note"].split(" | ");
      if (
        media_note[0] != null &&
        media_note[0] != "" &&
        media_note[0] == "album_hash"
      ) {
        isIS1AlbumHash = true;
      }
    }
  }

  if (isIS1AlbumHash) {
    return <div></div>;
  } else {
    return (
      <Card.Header
        onClick={onMouseClick}
        className={`p-0 ${category} ${project.name} ${media["media_type"] === mediumsConstants.VIDEO ? 'video-media-header' : ''}`}
        style={{
          borderColor: media["media_type"] === mediumsConstants.VIDEO ? 'transparent' : activeLabelColor
        }}
      >
        {/*<div onClick={onMouseClick} style={{backgroundImage: `url(${mediaUrl})`}} className={`media-bg-container ${isMediaOpacity? 'media-opacity': ''}`}>*/}
        {/*</div>*/}
        {content}
      </Card.Header>
    );
  }
};

const MediaDetail = ({ media, project }) => {
  if (!media) return null;

  // Group details by category for organized display (LeftColumn pattern)
  const mediaDetails = media.details || [];
  const groupedDetails = mediaDetails.reduce((acc, detail) => {
    const category = detail.detail_category;
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(detail);
    return acc;
  }, {});

  // Sort details within each category by idx
  Object.keys(groupedDetails).forEach(category => {
    groupedDetails[category].sort((a, b) => a.idx - b.idx);
  });

  const renderDetailSection = (categoryName, details) => (
    <Card className={`mb-3 border-0 shadow-sm ${styles['detail-section-card']}`} key={categoryName}>
      <div className={`${styles['standardized-section-header']}`}>
        <FontAwesomeIcon icon={categoryName === 'UserDetails' ? faUser : faFolder} className={styles['fa-icon-margin-right']} />
        <span role="heading" aria-level="3">
          {categoryName.replace(/([A-Z])/g, ' $1').trim()}
        </span>
      </div>
      <Card.Body className="py-2">
        {details.map((detail, index) => (
          <Row key={detail.id || index} className="mb-2 align-items-center">
            <Col xs={5} className="pe-1">
              <small className={`${styles['detail-label']} font-weight-medium`}>
                {detail.detail_type}:
              </small>
            </Col>
            <Col xs={7} className="ps-1">
              <small className={`${styles['detail-value']}`} title={detail.detail_description}>
                {detail.detail_description}
              </small>
            </Col>
          </Row>
        ))}
      </Card.Body>
    </Card>
  );
  // Check if note contains a GCP URL (storyboard URL)
  const isGcpStoryboard = media["note"] && (
    media["note"].includes('storage.googleapis.com') ||
    media["note"].includes('X-Goog-Algorithm') ||
    media["note"].startsWith('https://')
  );
  const localStoryBoard = isGcpStoryboard
    ? media["note"]
    : `${process.env.REACT_APP_BASE_URL}/storage/media/${project.id}/${media["note"]}`;
  console.log(localStoryBoard);

  return (
    <div className="mb-3">
      {/* Render grouped detail sections */}
      {Object.entries(groupedDetails).map(([categoryName, details]) =>
        renderDetailSection(categoryName, details)
      )}

      {/* Empty state */}
      {mediaDetails.length === 0 && (
        <Card className="border-0 shadow-sm">
          <Card.Body className="text-center py-4">
            <small className="text-muted">
              No context data available
            </small>
          </Card.Body>
        </Card>
      )}
      {media.img_check_details && media.img_check_details.storyboardurl && (
        <>
          {/* <AdvancedImage 
            src={localStoryBoard} 
            alt="Storyboard" 
            className="img-fluid" 
            title="Storyboard"
            fallbackSrc="/race_car_no_photo.png"
          /> */}
          <img
            src={localStoryBoard}
            alt="Storyboard"
            className="img-fluid"
            title="Storyboard"
          // onError={(e) => {
          //   e.target.src = "/race_car_no_photo.png";
          // }}
          />
        </>
      )}
    </div>
  );
};

const ActiveLabelText = ({ selectedLabelIds, labels }) => {
  const [activeLabelName, setActiveLabelName] = useState(null);
  const [activeLabelColor, setActiveLabelColor] = useState(null);
  useEffect(() => {
    // Use the first selected label for display
    const activeLabelId = selectedLabelIds && selectedLabelIds.length > 0 ? selectedLabelIds[0] : null;
    const label = _.find(labels, (el) => el.id === activeLabelId);
    let result = null;
    if (!label) {
      return;
    }
    if (label) {
      if (
        label.name == "ApproveImageAndDescription" ||
        label.name == "RejectDueToImage" ||
        label.name == "RejectDueToDescription" ||
        label.name == "RejectDueToImageAndDescription"
      ) {
        result = label.name.replace(/([A-Z])/g, " $1").trim();
      } else {
        result = label.name.toUpperCase();
      }
    }
    setActiveLabelName(result);
    setActiveLabelColor(label.color);
  }, [selectedLabelIds, labels]);
  return (
    <Button
      className="bg-transparent border-0 "
      style={{ color: activeLabelColor }}
    >
      <strong>{activeLabelName}</strong>
    </Button>
  );
};

const HeaderMediaId = ({ media, mediaInfo, project, showConvertedImage, onImageFormatToggle, onZoomClick, onStoryboardZoomClick, setDownloadModalUrl, setShowDownloadModal, setIsDownloadModalStoryboard, onVideoLengthMeasured }) => {
  const [show, setShow] = useState(false);
  const [copyError, setCopyError] = useState(false);
  const target = useRef(null);
  const [info, setInfo] = useState(null);
  const [downloadingOriginal, setDownloadingOriginal] = useState(false);
  const [downloadingStoryboard, setDownloadingStoryboard] = useState(false);
  const [videoLength, setVideoLength] = useState(null);
  let classNameInfo = "text-danger";
  const mediaType = media["media_type"];
  if (
    mediaType === mediumsConstants.GIF 
    // || mediaType === mediumsConstants.VIDEO
  ) {
    classNameInfo = "rainbow-text";
  }

  useEffect(() => {
    let result;
    if (mediaInfo) {
      result = mediaInfo.join(" | ");
    }
    setInfo(result);
  }, [mediaInfo]);

  const hideOverlay = () => {
    setTimeout(() => {
      setShow(false);
      setCopyError(false);
    }, 500);
  };

  const handleCopy = (text, result) => {
    if (result) {
      setShow(true);
      setCopyError(false);
    } else {
      // Fallback: try using the modern Clipboard API
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          setShow(true);
          setCopyError(false);
        }).catch(() => {
          setCopyError(true);
          setShow(true);
        });
      } else {
        setCopyError(true);
        setShow(true);
      }
    }
  };

  let projectName = project.name.replace(/ /g, "-");
  const normalizedProjectName = projectName ? projectName.toLowerCase() : '';
  let mediaDownloadStatus = media["media_download"]?.note;
  if (media["media_path"] == "download_failed") {
    mediaDownloadStatus = "Download failed";
  }
  const formatVideoLength = (seconds) => {
    if (!seconds || !isFinite(seconds)) {
      return null;
    }
    const totalSeconds = Math.floor(seconds);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;
    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, '0')}:${secs
        .toString()
        .padStart(2, '0')}`;
    }
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  };

  useEffect(() => {
    if (normalizedProjectName !== 'video') {
      setVideoLength(null);
      return;
    }

    const sourceUrl = GetMediaUrl(media, project, showConvertedImage);
    if (!sourceUrl || typeof document === 'undefined') {
      setVideoLength(null);
      return;
    }

    let isMounted = true;
    const videoElement = document.createElement('video');

    const handleLoadedMetadata = () => {
      if (!isMounted) {
        return;
      }
      setVideoLength(formatVideoLength(videoElement.duration));
      // Notify parent component with measured video length (in seconds)
      if (typeof onVideoLengthMeasured === 'function') {
        try {
          onVideoLengthMeasured(media.media_id, Math.floor(videoElement.duration));
        } catch (e) {
          // Ignore callback errors
        }
      }
    };

    const handleError = () => {
      if (isMounted) {
        setVideoLength(null);
      }
    };

    videoElement.preload = 'metadata';
    videoElement.addEventListener('loadedmetadata', handleLoadedMetadata);
    videoElement.addEventListener('error', handleError);
    videoElement.src = sourceUrl;
    videoElement.load();

    return () => {
      isMounted = false;
      videoElement.removeEventListener('loadedmetadata', handleLoadedMetadata);
      videoElement.removeEventListener('error', handleError);
      videoElement.removeAttribute('src');
      videoElement.load();
    };
  }, [
    normalizedProjectName,
    media?.media_id,
    media?.media_url,
    media?.media_path,
    project?.id,
    showConvertedImage,
    onVideoLengthMeasured,
    media.id
  ]);

  if (normalizedProjectName === 'video' && videoLength) {
    const durationLabel = `Length: ${videoLength}`;
    mediaDownloadStatus = mediaDownloadStatus
      ? `${mediaDownloadStatus} | ${durationLabel}`
      : durationLabel;
  }
  
  return (
    <div className="d-flex justify-content-between">
      <div className="d-flex align-items-center">
        <CopyToClipboard text={media["media_id"]} onCopy={handleCopy}>
          <a
            ref={target}
            className="ms-2 text-primary"
            style={{ cursor: 'pointer' }}
            title="Click to copy media ID"
          >
            {media["media_id"]}
          </a>
        </CopyToClipboard>
        {media["media_url"] && (
          <>
            <span className="ms-2 text-muted">&nbsp; | &nbsp;</span>
            <a
              href="#"
              className="ms-2 text-primary"
              title={media["media_path"]}
              onClick={async (e) => {
                e.preventDefault();
                if (downloadingOriginal) return;
                try {
                  setDownloadingOriginal(true);
                  const projectId = project?.id || '';
                  const apiUrl = `${process.env.REACT_APP_BASE_URL}/api/service/download-content?url=${encodeURIComponent(media["media_url"])}` + (projectId ? `&project_id=${projectId}` : '');
                  const res = await fetch(apiUrl);
                  const data = await res.json();
                  if (data && data.url) {
                    // Open in fullscreen modal
                    setIsDownloadModalStoryboard(false);
                    setDownloadModalUrl(data.url);
                    setShowDownloadModal(true);
                  } else {
                    alert('Failed to get download URL');
                  }
                } catch (err) {
                  alert('Failed to download media');
                } finally {
                  setDownloadingOriginal(false);
                }
              }}
            >
              {downloadingOriginal ? (
                <span>
                  Downloading... <Spinner animation="border" size="sm" className="ms-1" />
                </span>
              ) : (
                'Original'
              )}
            </a>
          </>
        )}
        <>
          <span className="ms-2 text-muted">&nbsp; | &nbsp;</span>
          <a
            href="#"
            className="ms-2 text-primary"
            title={media["media_path"]}
            onClick={(e) => {
              e.preventDefault();
              if (onZoomClick) onZoomClick();
            }}
          >
            Zoom
          </a>
        </>
        {/* Image Format Toggle Button - Always show for images */}
        {/* {media["media_type"] === mediumsConstants.IMAGE && (
          <>
            <span className="ms-2 text-muted">&nbsp; | &nbsp;</span>
            <Button
              onClick={onImageFormatToggle}
              className="bg-transparent border-0 p-0 m-0"
              style={{ color: '#007bff', textDecoration: 'underline' }}
              title="Toggle between converted and original image"
            >
              {showConvertedImage ? 'jpg' : media["media_download"]?.note }
            </Button>
          </>
        )} */}

        {/* {media.img_check_details && media.img_check_details.storyboardurl && (
          <>
            <span className="ms-2 text-muted">&nbsp; | &nbsp;</span>
            <a href={media.img_check_details.storyboardurl} target="_blank" className="ms-2 text-primary">
              Storyboard
            </a>
          </>
        )} */}
        {/* {media.img_check_details && media.img_check_details.manifesturl && (
          <>
            <span className="ms-2 text-muted">&nbsp; | &nbsp;</span>
            <a href={media.img_check_details.manifesturl} target="_blank" className="ms-2 text-primary">
              Manifest
            </a>
          </>
        )} */}
        {media.img_check_details && media.img_check_details.storyboardurl && media["media_type"] === mediumsConstants.VIDEO && (
          <>
            <span className="ms-2 text-muted">&nbsp; | &nbsp;</span>
            <a
              href="#"
              className="ms-2 text-primary"
              title="Download storyboard original"
              onClick={async (e) => {
                e.preventDefault();
                if (downloadingStoryboard) return;
                try {
                  setDownloadingStoryboard(true);
                  const projectId = project?.id || '';
                  const storyboardUrl = media.img_check_details.storyboardurl;
                  const apiUrl = `${process.env.REACT_APP_BASE_URL}/api/service/download-content?url=${encodeURIComponent(storyboardUrl)}` + (projectId ? `&project_id=${projectId}` : '');
                  const res = await fetch(apiUrl);
                  const data = await res.json();
                  if (data && data.url) {
                    // Open in fullscreen modal (storyboard is an image)
                    setIsDownloadModalStoryboard(true);
                    setDownloadModalUrl(data.url);
                    setShowDownloadModal(true);
                  } else {
                    alert('Failed to get storyboard download URL');
                  }
                } catch (err) {
                  alert('Failed to download storyboard');
                } finally {
                  setDownloadingStoryboard(false);
                }
              }}
            >
              {downloadingStoryboard ? (
                <span>
                  Downloading... <Spinner animation="border" size="sm" className="ms-1" />
                </span>
              ) : (
                'Storyboard Original'
              )}
            </a>
            <span className="ms-2 text-muted">&nbsp; | &nbsp;</span>
            <a
              href="#"
              className="ms-2 text-primary"
              title="Zoom storyboard image"
              onClick={(e) => {
                e.preventDefault();
                if (onStoryboardZoomClick) onStoryboardZoomClick();
              }}
            >
              Storyboard Zoom
            </a>
          </>
        )}
        
      </div>
      <Overlay
        target={target.current}
        placement="bottom"
        show={show}
        rootClose
        onHide={() => hideOverlay()}
      >
        <Popover id="popover-basic">
          <Popover.Header className={copyError ? "text-danger" : "text-success"}>
            {copyError ? "Copy Failed - Try manually selecting the text" : "Media ID Copied"}
          </Popover.Header>
        </Popover>
      </Overlay>

      <Button
        className={
          "bg-transparent border-0 shadow-none media-info-text pt-0 pb-1 " +
          classNameInfo +
          " " +
          projectName +
          "-media-info-text"
        }
      >
        <b>{info}</b> | <b className="media-download-status">{mediaDownloadStatus}</b>
      </Button>
    </div>
  );
};

// Selected Policies Display Component - Shows policy names as badges
const SelectedPoliciesDisplay = ({ selectedLabelIds, labels }) => {
  const [showAll, setShowAll] = useState(false);
  const maxDisplayCount = 3; // Show first 3 policies, then "+X more"

  // Get selected policy names
  const selectedPolicies = selectedLabelIds
    .map(id => labels.find(label => label.id === id))
    .filter(Boolean) // Remove any undefined labels
    .map(label => label.name);

  if (selectedPolicies.length === 0) {
    return null;
  }

  const displayPolicies = showAll ? selectedPolicies : selectedPolicies.slice(0, maxDisplayCount);
  const remainingCount = selectedPolicies.length - maxDisplayCount;

  return (
    <div className={styles['selected-policies-container']}>
      <div className={`d-flex flex-wrap align-items-center ${styles['policy-badges-container']}`}>
        {displayPolicies.map((policyName, index) => (
          <span
            key={`${policyName}-${index}`}
            className={`${styles['policy-badge']} me-2 mb-1`}
            title={policyName}
          >
            {policyName}
          </span>
        ))}

        {/* Show "+X more" button if there are more policies */}
        {!showAll && remainingCount > 0 && (
          <button
            className={`${styles['policy-badge']} ${styles['policy-badge-more']} me-2 mb-1`}
            onClick={() => setShowAll(true)}
            title={`Click to show ${remainingCount} more policies`}
          >
            +{remainingCount} more
          </button>
        )}

        {/* Show "Show less" button when expanded */}
        {showAll && selectedPolicies.length > maxDisplayCount && (
          <button
            className={`${styles['policy-badge']} ${styles['policy-badge-less']} me-2 mb-1`}
            onClick={() => setShowAll(false)}
            title="Click to show fewer policies"
          >
            Show less
          </button>
        )}
      </div>
    </div>
  );
};

export const SingleMediaBox = ({
  media,
  project,
  keyboard,
  position,
  hotkeys,
  handleFieldChange,
  openModal,
  is1AlbumCurrentIndexToShow,
  submitProcess,
  submitButtonStyle,
  canSubmit,
  isSubmit,
  sideInfo,
  onVideoLengthMeasured
}) => {
  //const media = developmentMedia;
  const [searchTerm, setSearchTerm] = useState('');
  const [submitError, setSubmitError] = useState('');
  const [showConvertedImage, setShowConvertedImage] = useState(false); // Default to converted image
  
  // Video state for controlling playback
  const [isPlaying, setIsPlaying] = useState(true); // Auto play enabled by default

  // Access user authentication state for role-based access control
  const user = useSelector(state => state.authentication.user);

  // Reset image format toggle when media changes
  // useEffect(() => {
  //   setShowConvertedImage(false); // Default to converted image for new media
  // }, [media.id]);

  // Determine if user can moderate (submit decisions)
  // Only regular moderators (non-admin, non-QA users) can submit moderation decisions
  // Admin and QA users have preview-only access
  // const canUserModerate = user && !user.is_admin_or_qa;
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const isPreview = params.get('preview') === 'true';
  const canUserModerate = !isPreview;

  // ===== USE CURRENT DATA SOURCE =====
  // This allows easy switching between mock and real data
  // Memoize labels processing to prevent infinite re-renders
  const { labels, labelsIS1Hash, firstLabel } = useMemo(() => {
    let { labels } = project;
    let labelsIS1Hash = [];
    let firstLabel = labels[0].id;

    if (project.name === projectsConstants.IS1_ALBUM) {
      labelsIS1Hash = labels
        .filter((label) => label.name === "Approve" || label.name === "Reject")
        .map((label) => {
          return label;
        });
      labels = labels
        .filter((label) => label.name !== "Approve" && label.name !== "Reject")
        .map((label) => {
          return label;
        });

      let _isIS1AlbumHash = false;
      if (media["note"] != null) {
        let media_note = media["note"].split(" | ");
        if (
          media_note[0] != null &&
          media_note[0] != "" &&
          media_note[0] == "album_hash"
        ) {
          _isIS1AlbumHash = true;
        }
      }
      if (_isIS1AlbumHash) {
        firstLabel = labelsIS1Hash[0].id;
      } else {
        firstLabel = labels[0].id;
      }
    }

    return { labels, labelsIS1Hash, firstLabel };
  }, [project, media]);

  // Zoom modal state
  const [showZoomModal, setShowZoomModal] = useState(false);
  const [zoomMediaUrl, setZoomMediaUrl] = useState('');
  const [isZoomingStoryboard, setIsZoomingStoryboard] = useState(false);

  // Download modal state
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [downloadModalUrl, setDownloadModalUrl] = useState('');
  const [isDownloadModalStoryboard, setIsDownloadModalStoryboard] = useState(false);

  // labelsIS1Image
  const [mediaInfo, setMediaInfo] = useState([]);
  const [selectedLabelIds, setSelectedLabelIds] = useState([]);
  const [ncmecValue, setNcmecValue] = useState('');
  const [storytellingLabelType, setStorytellingLabelType] = useState("Image");
  const [storytellingLabelImage, setStorytellingLabelImage] = useState("Okay");
  const storytellingLabelTypeHotkeys = ["q", "w", "e"];
  const storytellingLabelHotkeys = ["a", "s", "d"];
  const storytellingLabelBackHotkeys = ["z", "x", "c"];
  const is1AlbumHotkeys = ["q", "w", "e"];
  const is1AlbumZoomkeys = ["shift+q", "shift+w", "shift+e"];
  const zoomKey = `shift+${keyboard}`;
  const openMediaKey = `shift+${position + 1}`;
  const [is1AlbumIsShowing, setIs1AlbumIsShowing] = useState(false);

  useEffect(() => {
    // For multiple selection, pass the first selected label or null if none selected
    const primaryLabelId = selectedLabelIds.length > 0 ? selectedLabelIds[0] : null;
    handleFieldChange(media.id, primaryLabelId);
  }, [media, selectedLabelIds]); // Removed handleFieldChange from dependencies to prevent infinite re-renders

  // Reset selectedLabelIds when media changes to prevent stale state after reload
  useEffect(() => {
    setSelectedLabelIds([]);
  }, [media.id]);

  // useHotkeys(
  //   zoomKey,
  //   () => {
  //     if (project.name !== projectsConstants.IS1_ALBUM) {
  //       openModal(media);
  //     }
  //   },
  //   [media, openModal]
  // );

  // useHotkeys(
  //   is1AlbumZoomkeys.join(","),
  //   (event, handler) => {
  //     if (project.name === projectsConstants.IS1_ALBUM) {
  //       if (position !== 0) {
  //         // Not Album Hash
  //         if (
  //           handler.key === is1AlbumZoomkeys[(position - 1) % 3] &&
  //           is1AlbumCurrentIndexToShow - position >= 0 &&
  //           is1AlbumCurrentIndexToShow - position <= 2
  //         ) {
  //           openModal(media);
  //         }
  //       }
  //     }
  //   },
  //   [keyboard, media, openModal]
  // );

  // useHotkeys(
  //   openMediaKey,
  //   () => {
  //     window.open(media["media_url"]);
  //   },
  //   [media]
  // );

  const changeLabel = (prev) => {
    if (prev === undefined) {
      prev = selectedLabelIds.length > 0 ? selectedLabelIds[0] : null;
    }

    let nextIndex = 0;
    let labelIndex;
    if (project.name === projectsConstants.STORYTELLING_QUEUE2) {
      if (storytellingLabelImage === "Escalate") {
        setStorytellingLabelImage(labels[labels.length - 1].name);
        nextIndex = labels.length - 1;
      } else {
        let storytellingLabel =
          storytellingLabelType + "_" + storytellingLabelImage;
        labelIndex = _.findIndex(labels, (el) => el.name === storytellingLabel);
        nextIndex = labels[labelIndex + 1] ? labelIndex + 1 : 0;
        setStorytellingLabelImage(labels[nextIndex].name.split("_")[1]);
      }
    } else {
      labelIndex = _.findIndex(labels, (el) => el.id === prev);
    }

    if (labelIndex !== undefined) {
      nextIndex = labels[labelIndex + 1] ? labelIndex + 1 : 0;
    }
    return labels[nextIndex].id;
  };

  const changeLabelBackward = (prev) => {
    if (prev === undefined) {
      prev = selectedLabelIds.length > 0 ? selectedLabelIds[0] : null;
    }
    let nextIndex = 0;
    let labelIndex;
    if (project.name === projectsConstants.STORYTELLING_QUEUE2) {
      if (storytellingLabelImage === "Okay") {
        setStorytellingLabelImage(labels[labels.length - 1].name);
        nextIndex = labels.length - 1;
      } else {
        let storytellingLabel =
          storytellingLabelType + "_" + storytellingLabelImage;
        labelIndex = _.findIndex(labels, (el) => el.name === storytellingLabel);
        nextIndex = labels[labelIndex - 1] ? labelIndex - 1 : 8;
        setStorytellingLabelImage(labels[nextIndex].name.split("_")[1]);
      }
    } else {
      labelIndex = _.findIndex(labels, (el) => el.id === prev);
    }

    if (labelIndex !== undefined) {
      nextIndex = labels[labelIndex - 1] ? labelIndex - 1 : 0;
    }
    return labels[nextIndex].id;
  };

  // useHotkeys(
  //   hotkeys.join(","),
  //   (event, handler) => {
  //     if (project.name === projectsConstants.STORYTELLING_QUEUE2) {
  //       if (handler.key === storytellingLabelTypeHotkeys[position]) {
  //         setStorytellingLabelType((prev) => {
  //           if (prev === "Image") {
  //             return "Illustration";
  //           } else {
  //             return "Image";
  //           }
  //         });
  //       }
  //     } else if (project.name === projectsConstants.IS1_ALBUM) {
  //       if (position !== 0) {
  //         // Not Album Hash
  //         if (
  //           handler.key === is1AlbumHotkeys[(position - 1) % 3] &&
  //           is1AlbumCurrentIndexToShow - position >= 0 &&
  //           is1AlbumCurrentIndexToShow - position <= 2
  //         ) {
  //           const newLabelId = changeLabel();
  //           setSelectedLabelIds([newLabelId]);
  //         }
  //       }
  //     } else {
  //       if (handler.key === keyboard) {
  //         const newLabelId = changeLabel();
  //         setSelectedLabelIds([newLabelId]);
  //       }
  //     }
  //   },
  //   [keyboard, changeLabel, hotkeys]
  // );

  const handleCheckboxChange = (event, labelId) => {
    if (project.name === projectsConstants.STORYTELLING_QUEUE2) {
      if (labelId === "Image" || labelId === "Illustration") {
        setStorytellingLabelType(labelId);
      } else {
        setStorytellingLabelImage(labelId);
      }
      if (labelId === "Broken") {
        for (var i = 0; i < labels.length; i++) {
          if (labels[i].name === labelId) {
            setSelectedLabelIds([labels[i].id]);
          }
        }
      }
      if (event && event.target) {
        event.target.blur();
      }
    } else {
      // Always single-select for radio
      setSelectedLabelIds([labelId]);
    }
  };

  const handleMouseClickMedia = () => {
    const newLabelId = changeLabel();
    setSelectedLabelIds([newLabelId]);
  };
  const updateMediaInfo = (info) => {
    setMediaInfo((pre) => {
      return [...pre, info];
    });
  };

  const onFocusRadio = (event, labelId) => {
    event.target.blur();
  };

  let note = "";
  const photoCategory = (url, project) => {
    if (project.name === "Kids" && url.includes("/com/")) {
      // note = "Lưu ý:\n .";
      return "us";
    }
    return "other";
  };

  const decodeNote = (note) => {
    if (
      project.name === projectsConstants.RACECAR ||
      project.name === projectsConstants.LOVE
    ) {
      try {
        return JSON.parse(note);
      } catch (e) {
        return note;
      }
    }
    return note;
  };

  const currentLabel = selectedLabelIds.length > 0 ? _.find(labels, (el) => el.id === selectedLabelIds[0]) : null;

  let preContent = "";
  let postContent = "";
  let middleContent = "";
  let noteAI = "";

  let labelType = "";
  let labelList = "";
  let isIS1AlbumHash = false;

  labelList = labels.map((label, index) => (
    <Form.Group
      controlId={`control-${label.id}-${media.id}`}
      className="mb-1"
      key={`group-label-${index}`}
    >
      <Form.Check
        name={`group-${media.id}`}
        type="radio"
        label={label.name}
        checked={selectedLabelIds.includes(label.id)}
        onChange={(event) => handleCheckboxChange(event, label.id)}
        onFocus={(event) => onFocusRadio(event, label.id)}
        title={label.definition ? label.definition : "N/A"}
      />
    </Form.Group>
  ));
  // }

  let mediaClassName =
    project.name === projectsConstants.IS1_ALBUM && !is1AlbumIsShowing
      ? "hide"
      : "show";

  // Filter labels based on search term (RightColumn pattern)
  const filteredLabels = labels.filter(label =>
    label.name.toLowerCase().includes(searchTerm.toLowerCase())
  );



  // Extract caption from media note (MiddleColumn pattern)
  const getCaption = (media) => {
    if (media.note) {
      const noteParts = media.note.split(" | ");
      // Try to get the description part (usually the second part)
      let description = noteParts[1] || "";

      // If second part is empty or just quotes, try first part
      if (!description || description.trim() === '""' || description.trim() === '') {
        description = noteParts[0] || "";
      }

      // Clean up the description
      if (description && description !== "JsonQueue" && description.trim() !== "") {
        // Remove surrounding quotes if present
        description = description.replace(/^["']|["']$/g, '');
        return description.trim();
      }
    }
    return "test video description";
  };

  const caption = getCaption(media);

  const history = useHistory();

  // Handler for Submit & Leave
  const validateSubmit = () => {
    if (selectedLabelIds.length === 0) {
      setSubmitError('Please select at least one policy before submitting.');
      return false;
    }
    const csamLabel = labels.find(label => label.name.includes('CSAM') && selectedLabelIds.includes(label.id));
    if (csamLabel && !ncmecValue) {
      setSubmitError('Please select a NCMEC classification for CSAM.');
      return false;
    }
    setSubmitError('');
    return true;
  };

  const handleSubmit = async () => {
    if (!validateSubmit()) return;
    await submitProcess();
  };

  const handleImageFormatToggle = () => {
    setShowConvertedImage(!showConvertedImage);
  };

  const handleZoomClick = () => {
    // Pause main video if it's a video
    if (media["media_type"] === mediumsConstants.VIDEO && isPlaying) {
      setIsPlaying(false);
    }

    // Get the media URL
    const server = process.env.REACT_APP_BASE_URL;
    const isGcpUrl = media['media_path'] && (
      media['media_path'].includes('storage.googleapis.com') ||
      media['media_path'].includes('X-Goog-Algorithm') ||
      media['media_path'].startsWith('https://')
    );

    let mediaUrl;
    if (isGcpUrl) {
      mediaUrl = media['media_path'];
    } else {
      mediaUrl = `${server}storage/media/${project.id}/${media['media_path']}`;
    }

    setIsZoomingStoryboard(false);
    setZoomMediaUrl(mediaUrl);
    setShowZoomModal(true);
  };

  const handleStoryboardZoomClick = () => {
    // Pause main video if it's a video
    if (media["media_type"] === mediumsConstants.VIDEO && isPlaying) {
      setIsPlaying(false);
    }

    // Get the storyboard URL
    const isGcpStoryboard = media["note"] && (
      media["note"].includes('storage.googleapis.com') ||
      media["note"].includes('X-Goog-Algorithm') ||
      media["note"].startsWith('https://')
    );

    let storyboardUrl;
    if (isGcpStoryboard) {
      storyboardUrl = media["note"];
    } else {
      storyboardUrl = `${process.env.REACT_APP_BASE_URL}/storage/media/${project.id}/${media["note"]}`;
    }

    setIsZoomingStoryboard(true);
    setZoomMediaUrl(storyboardUrl);
    setShowZoomModal(true);
  };

  const submitAndLeave = async () => {
    // if (!validateSubmit()) return;
    // const result = await submitProcess();
    // if (result) {
    //   history.push('/');
    // }

    if (!validateSubmit()) return;
    try {
      await submitProcess();
    } catch (error) {
      console.error('Submit process failed:', error);
    } finally {
      // Always navigate to homepage after submit attempt
      history.push('/');
    }
  };

  // Move space hotkey handling here so each SingleMediaBox runs its own validation
  // useHotkeys('space', (event, handler) => {
  //   // prevent page scroll when pressing space
  //   event.preventDefault();

  //   // run local validation first
  //   if (!validateSubmit()) return;

  //   // call parent submitProcess (same as previous global handler)
  //   if (typeof submitProcess === 'function') {
  //     submitProcess();
  //   }
  // }, [validateSubmit, submitProcess, canSubmit, isSubmit]);

  return (
    <div className={`${styles['single-project-page']}`}>
      
      {/* Top Section - Inspired by TopSection.js */}
      <div className={`${styles['top-navigation-bar']}`}>
        <div className={`${styles['nav-container']}`}>
          <div className={`${styles['nav-left']}`}>
            <div className={`${styles['project-info']}`}>
              <div className={`${styles['project-icon-wrapper']}`}>
                <FontAwesomeIcon
                  icon={faProjectDiagram}
                  className={`${styles['project-icon']}`}
                  aria-hidden="true"
                />
              </div>
              <h1 className={`${styles['project-name']}`}>
                {project?.name || 'Unknown Project'}
              </h1>
            </div>
            <div className={`${styles['moderation-mode']}`}>
              <span className={`${styles['moderation-text']}`}>
                {canUserModerate ? 'Moderation Mode' : 'Preview Mode'}
              </span>
              <div className={`${styles['eye-icon-wrapper']}`}>
                <FontAwesomeIcon
                  icon={canUserModerate ? faGavel : faEye}
                  className={`${styles['eye-icon']}`}
                  aria-hidden="true"
                />
              </div>
            </div>
            <div className="d-flex align-items-center ms-3">
              {sideInfo && (
                <div style={{ color: '#495057' }}>
                  Pending: {sideInfo.requests_pending || 0} &nbsp;|&nbsp;
                  Downloaded: {sideInfo.requests_downloaded || 0} &nbsp;|&nbsp;
                  <span title="Today submitted requests / Today requests">Submitted:</span> <span title="Today submitted requests"> {sideInfo.requests_submitted || 0} </span> / <span title="Today requests"> {sideInfo.requests_allOfTheDay || 0}</span>
                </div>
              )}
            </div>
          </div>
          <div className={`${styles['nav-right']}`}>
            <Attendance />
            {/* <Badge
              bg={media["media_type"] === mediumsConstants.VIDEO ? 'danger' :
                  media["media_type"] === mediumsConstants.GIF ? 'warning' : 'primary'}
              className="me-2"
            >
              {media["media_type"] === mediumsConstants.VIDEO ? 'Video' :
               media["media_type"] === mediumsConstants.GIF ? 'GIF' : 'Image'}
            </Badge>
            <small className="text-muted">ID: {media["media_id"]}</small> */}
          </div>
        </div>
      </div>

      {/* Three Column Layout */}
      <Row className={`${styles['three-column-layout']} g-0`}>
        {/* Left Column - Enhanced with LeftColumn.js patterns */}
        {/* <Col xl={3} lg={3} className="pe-2">
          <div className={`${styles['project-context']}`}>
            <MediaDetail media={media} project={project} />
          </div>
        </Col> */}

        {/* Middle Column - Enhanced with MiddleColumn.js patterns */}
        <Col xl={9} lg={9} className="px-2">
          <div className={`${styles['media-queue']}`}>
            <div className={styles['queue-content']}>
              <div className={`${styles['single-media']} ${mediaClassName}`}>
                <Watermark
                  media={media}
                  project={project}
                  index={position}
                  currentLabel={currentLabel}
                  onMouseClick={handleMouseClickMedia}
                />


                <Card className="bg-transparent border-0 shadow-sm">
                  {/* Only render preContent for non-video media types */}
                  {media["media_type"] !== mediumsConstants.VIDEO && preContent}

                  {/* Video ID and Status positioned above video player in top-right area */}
                  <div className="mb-2">
                    <HeaderMediaId
                      media={media}
                      mediaInfo={mediaInfo}
                      project={project}
                      showConvertedImage={showConvertedImage}
                      onImageFormatToggle={handleImageFormatToggle}
                      onZoomClick={handleZoomClick}
                      onStoryboardZoomClick={handleStoryboardZoomClick}
                      setDownloadModalUrl={setDownloadModalUrl}
                      setShowDownloadModal={setShowDownloadModal}
                      setIsDownloadModalStoryboard={setIsDownloadModalStoryboard}
                      onVideoLengthMeasured={onVideoLengthMeasured}
                    />
                  </div>

                  <Media
                    media={media}
                    labels={isIS1AlbumHash ? labelsIS1Hash : labels}
                    selectedLabelIds={selectedLabelIds}
                    onMouseClick={media["media_type"] === mediumsConstants.VIDEO ? null : handleMouseClickMedia}
                    project={project}
                    updateMediaInfo={updateMediaInfo}
                    category={photoCategory(media["media_url"], project)}
                    showConvertedImage={showConvertedImage}
                    isPlaying={isPlaying}
                    setIsPlaying={setIsPlaying}
                  />

                  {/* Only render postContent and middleContent for non-video media types */}
                  {media["media_type"] !== mediumsConstants.VIDEO && postContent}

                  {media["media_type"] !== mediumsConstants.VIDEO && middleContent}
                  {/* { middleContent != "" &&
                    (<div>report count: {middleContent}</div>)
                } */}

                  {/* Conditionally render entire Card.Body section - hide for VIDEO media type */}
                  {media["media_type"] !== mediumsConstants.VIDEO && (
                    <Card.Body>
                      <div className="d-flex">
                        {/* <a
                          href={media["media_url"]}
                          target="_blank"
                          className="pe-2"
                          rel="noopener noreferrer"
                        >
                          <Button className="bg-transparent border-0">Original</Button>
                        </a> */}
                        <Button
                          onClick={() => openModal(media)}
                          className="bg-transparent border-0"
                        >
                          Zoom
                        </Button>

                        {project.name !== projectsConstants.IS1_ALBUM ? (
                          <ActiveLabelText
                            selectedLabelIds={selectedLabelIds}
                            labels={isIS1AlbumHash ? labelsIS1Hash : labels}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                      {project.name === projectsConstants.IS1_ALBUM ? (
                        <ActiveLabelText
                          selectedLabelIds={selectedLabelIds}
                          labels={isIS1AlbumHash ? labelsIS1Hash : labels}
                        />
                      ) : (
                        ""
                      )}

                      {labelType}
                      <hr className={styles['bg-purple']} />
                    </Card.Body>
                  )}
                </Card>

                {/* Caption Area - Positioned above video player */}
                {/* <div className="mb-3 mt-3">
                  <div className={`${styles['standardized-section-header']} mb-0`}>
                    <FontAwesomeIcon icon={faQuoteLeft} className={styles['fa-icon-margin-right']} />
                    <span>Caption</span>
                  </div>
                  <Card className={`border-0 shadow-sm ${styles['caption-card-no-margin-top']}`}>
                    <Card.Body className={`p-3 ${styles['caption-card-body']}`}>
                      <p className={`mb-0 ${styles['caption-text-content']}`}>
                        {caption || "test video description"}
                      </p>
                    </Card.Body>
                  </Card>
                </div> */}

                {media["media_type"] !== mediumsConstants.VIDEO && media["media_type"] !== mediumsConstants.IMAGE && (
                  <>
                    <div className={`note-${project.name}`}>{note}</div>
                    <div className={`note-${project.name}`}>{noteAI}</div>
                  </>
                )}
                {/*<ModalMedia show={modalShow === mediaId} onHide={() => setModalShow(null)} media={media} project={project}/>*/}
              </div>
            </div>
          </div>
        </Col>

        {/* Right Column - Enhanced with RightColumn.js patterns */}
        <Col xl={3} lg={3} className="ps-2">
          <div className={`${styles['policy-selection']}`}>
            <div className={`${styles['standardized-section-header']}`}>
              <FontAwesomeIcon icon={faGavel} className={styles['fa-icon-margin-right']} />
              <span>Policy Selection {!canUserModerate && '(Preview Only)'}</span>
            </div>
            <p className={`text-muted mb-4 ${styles['policy-description-text']}`}>
              {canUserModerate
                ? 'Choose applicable policies for this case'
                : 'View available policies (selection disabled in preview mode)'
              }
            </p>

            {/* Enhanced Search Labels Section */}
            <div className="mb-4">
              <h6 className={`text-dark font-weight-medium mb-2 ${styles['search-labels-header']}`}>
                Search Policies
              </h6>
              <div className="position-relative">
                <Form.Control
                  type="text"
                  placeholder="Policy Name"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className={styles['search-input-field']}
                />
                <FontAwesomeIcon
                  icon={faSearch}
                  className={`position-absolute ${styles['search-icon-positioned']}`}
                />
              </div>
            </div>

            {/* Enhanced Available Labels Section */}
            <div className="mb-4">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <h6 className={`text-dark font-weight-medium mb-0 ${styles['available-labels-header']}`}>
                  Available Policies
                </h6>
                <Badge
                  variant="secondary"
                  className={`px-2 py-1 ${styles['label-count-badge']}`}
                >
                  {filteredLabels.length}
                </Badge>
              </div>

              <div className={styles['labels-container']}>
                {filteredLabels.length > 0 ? (
                  <div className="p-2">
                    {filteredLabels.map((label, index) => (
                      <Form.Group
                        controlId={`control-${label.id}-${media.id}`}
                        className="mb-1"
                        key={`group-label-${index}`}
                      >
                        <div
                          className={`d-flex ${label.name.includes('CSAM') && selectedLabelIds.includes(label.id) ? 'align-items-start' : 'align-items-center'} py-2 px-3 ${styles['policy-item']} ${styles['policy-item-container']}`}
                          style={{
                            backgroundColor: selectedLabelIds.includes(label.id) ? '#f8f9fa' : 'transparent',
                            cursor: canUserModerate ? 'pointer' : 'default',
                            opacity: canUserModerate ? 1 : 0.7
                          }}
                          onClick={canUserModerate ? () => handleCheckboxChange(null, label.id) : undefined}
                        >
                          <Form.Check
                            name={`group-${media.id}`}
                            type="radio"
                            checked={selectedLabelIds.includes(label.id)}
                            onChange={canUserModerate ? (event) => handleCheckboxChange(event, label.id) : undefined}
                            onFocus={(event) => onFocusRadio(event, label.id)}
                            title={label.definition ? label.definition : "N/A"}
                            className={`me-3 ${styles['radio-button-scaled']} ${label.name.includes('CSAM') && selectedLabelIds.includes(label.id) ? '' : ''} ${styles['form-check-input-custom']}`}
                            disabled={!canUserModerate}
                          />
                          <div className="flex-grow-1">
                            <div className="d-flex align-items-center justify-content-between">
                              <span
                                className={`font-weight-medium text-dark ${styles['label-name-text']}`}
                              >
                                {label.name}
                              </span>
                              <div className="d-flex align-items-center">
                                {label.definition && (
                                  <OverlayTrigger
                                    placement="left"
                                    overlay={
                                      <Tooltip id={`tooltip-${label.id}`} className={styles['tooltip-max-width']}>
                                        <div
                                          className={styles['tooltip-content-formatted']}
                                          dangerouslySetInnerHTML={{ __html: label.definition }}
                                        />
                                      </Tooltip>
                                    }
                                  >
                                    <FontAwesomeIcon
                                      icon={faEye}
                                      className={`me-2 ${styles['label-definition-icon']}`}
                                      onClick={(e) => e.stopPropagation()}
                                    />
                                  </OverlayTrigger>
                                )}
                              </div>
                            </div>
                            {label.name.includes('CSAM') && selectedLabelIds.includes(label.id) && (
                              <div className="mt-2 ms-4 ncmec-form-check" style={{ position: 'relative' }}>
                                {/* Hardcoded NCMEC type descriptions */}
                                {(() => {
                                  const ncmecTypeDescriptions = {
                                    A1: 'A1: A minor who, based on the totality of the circumstances, does not appear to have reached the onset of puberty.',
                                    A2: 'A2: A minor who, based on the totality of the circumstances, appears to have reached the onset of puberty.',
                                    B1: 'B1: Any imagery depicting sexual intercourse (including genital-genital, oral-genital, anal-genital, or oral-anal whether between persons of the same or opposite sex), bestiality, masturbation, sadistic or masochistic abuse, degradation, or any such depiction of the above that lacks serious literary, artistic, political, or scientific value.',
                                    B2: 'B2: Any imagery depicting the lascivious exhibition of the anus, genitals, or pubic area of any person, where a minor is engaging in the lascivious exhibition or being used in connection with sexually explicit conduct, which may include but is not limited to imagery where the focal point is on the child’s anus, genitals, or pubic area and where the depiction is intended or designed to elicit a sexual response in the viewer.',
                                  };
                                  return (
                                    <Form.Group>
                                      {['A1', 'A2', 'B1', 'B2'].map((ncmecType) => (
                                        <div key={`ncmec-row-${ncmecType}`} className="d-flex align-items-center justify-content-between mb-1">
                                          <Form.Check
                                            type="radio"
                                            name={`ncmec-${media.id}`}
                                            label={ncmecType}
                                            id={`ncmec-${ncmecType}-${media.id}`}
                                            className={`${styles['ncmec-form-check']}`}
                                            onChange={() => {
                                              setNcmecValue(ncmecType);
                                            }}
                                            checked={ncmecValue === ncmecType}
                                            disabled={!canUserModerate}
                                          />
                                          <div className="ms-2 d-flex align-items-center" style={{ marginLeft: 'auto' }}>
                                            <OverlayTrigger
                                              placement="left"
                                              overlay={
                                                <Tooltip id={`tooltip-ncmec-${ncmecType}`} className={styles['tooltip-max-width']}>
                                                  <div
                                                    className={styles['tooltip-content-formatted']}
                                                    dangerouslySetInnerHTML={{ __html: ncmecTypeDescriptions[ncmecType] }}
                                                  />
                                                </Tooltip>
                                              }
                                            >
                                              <FontAwesomeIcon
                                                icon={faEye}
                                                className={`me-2 ${styles['label-definition-icon']}`}
                                                onClick={(e) => e.stopPropagation()}
                                              />
                                            </OverlayTrigger>
                                          </div>
                                        </div>
                                      ))}
                                    </Form.Group>
                                  );
                                })()}
                              </div>
                            )}
                          </div>
                        </div>
                      </Form.Group>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-4">
                    <small className="text-muted">
                      {searchTerm ? 'No labels match your search' : 'No labels available'}
                    </small>
                  </div>
                )}
              </div>
            </div>

            {/* Selected Policies Display - Full Width */}
            <div className="mb-3">
              <div className={`w-100 px-3 py-3 ${styles['selection-counter-full-width']} ${selectedLabelIds.length > 0 ? styles['has-selections'] : ''}`}>
                <div className="d-flex align-items-center mb-2">
                  <i className={`fas fa-check-circle me-2 ${selectedLabelIds.length > 0 ? 'text-success' : 'text-primary'}`}></i>
                  <span className="font-weight-medium text-dark">
                    {selectedLabelIds.length === 0
                      ? 'No policies selected'
                      : `${selectedLabelIds.length} ${selectedLabelIds.length === 1 ? 'policy' : 'policies'} selected:`
                    }
                  </span>
                </div>

                {/* Selected Policy Names Display */}
                {selectedLabelIds.length > 0 && (
                  <SelectedPoliciesDisplay
                    selectedLabelIds={selectedLabelIds}
                    labels={isIS1AlbumHash ? labelsIS1Hash : labels}
                  />
                )}
              </div>
            </div>

            {/* Enhanced Submit Button - Only show for moderators */}
            {canUserModerate ? (
              <div className="mb-4">
                {submitError && (
                  <div className="alert alert-danger text-center mb-2">
                    <small>{submitError}</small>
                  </div>
                )}
                <Button
                  onClick={handleSubmit}
                  type="button"
                  variant={submitButtonStyle}
                  size="lg"
                  disabled={!canSubmit}
                  className={`w-100 font-weight-bold mb-4 ${styles['submit-button-styled']}`}
                  style={{
                    backgroundColor: submitButtonStyle === 'primary' ? '#6c757d' : '#e9ecef',
                    borderColor: submitButtonStyle === 'primary' ? '#6c757d' : '#e9ecef',
                    color: submitButtonStyle === 'primary' ? '#fff' : '#6c757d'
                  }}
                >
                  {isSubmit ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Processing...
                    </>
                  ) : (
                    'Submit'
                  )}
                </Button>
                <Button
                  onClick={submitAndLeave}
                  type="button"
                  variant={submitButtonStyle}
                  size="lg"
                  disabled={!canSubmit}
                  className={`w-100 font-weight-bold mb-4 ${styles['submit-button-styled']}`}
                  style={{
                    backgroundColor: submitButtonStyle === 'primary' ? '#6c757d' : '#e9ecef',
                    borderColor: submitButtonStyle === 'primary' ? '#6c757d' : '#e9ecef',
                    color: submitButtonStyle === 'primary' ? '#fff' : '#6c757d'
                  }}
                >
                  {isSubmit ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Processing...
                    </>
                  ) : (
                    'Submit & Leave'
                  )}
                </Button>
              </div>
            ) : (
              <div className="mb-4">
                <div className="alert alert-info text-center">
                  <small>
                    <strong>Preview Mode:</strong> You can view queue media but cannot submit moderation decisions.
                  </small>
                </div>
              </div>
            )}

            {/* More Actions Dropdown - Only show for moderators canUserModerate */}
            {/* {(user != null && user.user_name.toLowerCase() === 'luanvu') && (
              <div className="mb-3">
                <Dropdown className="w-100">
                  <Dropdown.Toggle
                    variant="outline-secondary"
                    className="w-100 border-0 shadow-none"
                    style={{
                      backgroundColor: 'transparent',
                      color: '#6c757d',
                      borderColor: 'transparent',
                      outline: 'none',
                      boxShadow: 'none'
                    }}
                  >
                    More Actions
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="w-100">
                    <Dropdown.Item
                      onClick={() => window.location.reload()}
                      className="text-center"
                    >
                      Refresh
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => window.open(`/report/${user['user_name']}/?project_id=${project.id}`, '_blank')}
                      className="text-center"
                    >
                      Report
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            )} */}
          </div>
        </Col>
      </Row>
{/* Zoom Modal */}
<Modal
        show={showZoomModal}
        onHide={() => setShowZoomModal(false)}
        centered
        size="xl"
        dialogClassName="media-zoom-modal"
        style={{
          maxWidth: '100%',
          width: '100%',
          margin: 0
        }}
        backdropClassName="zoom-modal-backdrop"
      >
         <Modal.Body
           className="p-3"
           style={{
             backgroundColor: 'rgba(255, 255, 255, 0.5)',
             minHeight: isZoomingStoryboard ? 'auto' : '90vh'
           }}
         >
           <MediaContainer
             url={zoomMediaUrl}
             mediaType={isZoomingStoryboard ? mediumsConstants.IMAGE : media["media_type"]}
             onClose={() => setShowZoomModal(false)}
             isStoryboard={isZoomingStoryboard}
           />
        </Modal.Body>
      </Modal>

      {/* Download Modal */}
      <Modal
        show={showDownloadModal}
        onHide={() => setShowDownloadModal(false)}
        centered
        size="xl"
        dialogClassName="media-zoom-modal"
        style={{
          maxWidth: '100%',
          width: '100%',
          margin: 0
        }}
        backdropClassName="zoom-modal-backdrop"
      >
         <Modal.Body
           className="p-3"
           style={{
             backgroundColor: 'rgba(255, 255, 255, 0.5)',
             minHeight: '90vh'
           }}
         >
           {isDownloadModalStoryboard ? (
            <MediaContainer
               url={downloadModalUrl}
               mediaType={mediumsConstants.IMAGE}
               onClose={() => setShowDownloadModal(false)}
               isStoryboard={true}
             />
           ) : (
             <MediaContainer
               url={downloadModalUrl}
               mediaType={media["media_type"]}
               onClose={() => setShowDownloadModal(false)}
               isStoryboard={false}
             />
           )}
        </Modal.Body>
      </Modal>
      
    </div>
  );
};

const Watermark = ({ media, project, index, currentLabel, onMouseClick }) => {
  // if (project.name === "Kids") {
  //   let currentLabelCss = "";
  //   if (currentLabel.name === "Reject" || currentLabel.name === "Broken") {
  //     currentLabelCss = " watermark-" + currentLabel.name;
  //   }

  //   return (
  //     <div
  //       id={"watermark-" + media["media_id"]}
  //       className={"watermark-" + index + currentLabelCss}
  //   );
  // }

  // if (project.name === projectsConstants.STORYTELLING_QUEUE2) {
  //   let currentLabelCss = "";
  //   if (
  //     currentLabel.name === "Image_Explicit" ||
  //     currentLabel.name === "Illustration_Explicit"
  //   ) {
  //     currentLabelCss = " watermark-" + currentLabel.name;
  //   }

  //   return (
  //     <div
  //       id={"watermark-" + media["media_id"]}
  //       className={"watermark-" + index + currentLabelCss}
  //       onClick={onMouseClick}
  //     >
  //       <p className={"bg-text-" + currentLabel.name}>{currentLabel.name}</p>
  //     </div>
  //   );
  // }

  return "";
};
